import HttpService from "@/modules/core/network/http-service";

class EquipmentService extends HttpService {
  constructor() {
    super("stock/equipment");
  }
}

export default new EquipmentService();
